<div class="role-item">
  <div class="role-item__left">
    <svg class="role-item__left-icon" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="26" cy="26" r="26" [attr.fill]="color"/>
      <path
        d="M20.668 19.4583C20.668 20.7402 21.1772 21.9696 22.0836 22.876C22.99 23.7824 24.2194 24.2917 25.5013 24.2917C26.7832 24.2917 28.0126 23.7824 28.919 22.876C29.8254 21.9696 30.3346 20.7402 30.3346 19.4583C30.3346 18.1765 29.8254 16.9471 28.919 16.0407C28.0126 15.1342 26.7832 14.625 25.5013 14.625C24.2194 14.625 22.99 15.1342 22.0836 16.0407C21.1772 16.9471 20.668 18.1765 20.668 19.4583Z"
        stroke="white" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"/>
      <path
        d="M18.25 36.375V33.9583C18.25 32.6765 18.7592 31.4471 19.6657 30.5407C20.5721 29.6342 21.8015 29.125 23.0833 29.125H27.9167C29.1985 29.125 30.4279 29.6342 31.3343 30.5407C32.2408 31.4471 32.75 32.6765 32.75 33.9583V36.375"
        stroke="white" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  <div class="role-item__right">
    <h2 class="role-item__right-title">{{roleItem?.name}}</h2>
    <p class="role-item__right-description">{{'ROLE_PAGE.USER_COUNT' | translate}} {{roleItem?.user_qty}}</p>
    <p class="role-item__right-description">{{'ROLE_PAGE.CREATE_DATE' | translate}} {{roleItem?.creation_date}}</p>
  </div>
  <div class="role-item__btn-block">
    <button
      *appHasAccess="['ROLES_DELETE']"
      (click)="openDeleteModal($event)"
      class="btn-icon">
      <img
        src="assets/img/delete.svg"
        alt="Delete icon"
        class="btn-icon__image">
    </button>
  </div>
</div>

